import { render, staticRenderFns } from "./baseHospital.vue?vue&type=template&id=d737b25a&"
import script from "./baseHospital.vue?vue&type=script&lang=js&"
export * from "./baseHospital.vue?vue&type=script&lang=js&"
import style0 from "./baseHospital.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports